import { render, staticRenderFns } from "./VPopover.vue?vue&type=template&id=a4513b10&"
import script from "./VPopover.vue?vue&type=script&lang=ts&"
export * from "./VPopover.vue?vue&type=script&lang=ts&"
import style0 from "./VPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports